import React from "react";
import BlogListingPresenter from "./BlogListing.presenter";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { MapStateToProps, MapDispatchToProps, C_Props, MergedProps, C_States } from "./BlogListing.type";
import {
  AppNotifications,
  BlogCategoryApiOutputModel,
  BlogOutputModel,
  BlogStatus,
  LanguageOutputModel,
  RootState,
  TCb,
} from "../../../models";
import { AllLabelsActions, AllLanguageListActions, NotificationActions } from "../../../store/actions";
import _ from "lodash";

import { APP_ROUTES, BLOG_CATEGORY, INITIAL_FETCHING_PAGINATION_DATA, CATEGORY_TYPES } from "../../../constants";

import { BlogService, CategoryService } from "../../../services";
import { BlogUtil, loadCallback } from "../../../utils";
import { withRouter } from "react-router-dom";

const EMPTY_FILTER: C_States["filter"] = {
  categoryId: "",
  categoryUrl: "",
  searchValue: "",
};

class BlogListingContainer extends React.Component<MergedProps, C_States> {
  constructor(props) {
    super(props);
    const blogId = this.props.match.params.blogId;

    this.state = {
      filter: EMPTY_FILTER,
      fetchedBlog: INITIAL_FETCHING_PAGINATION_DATA,
      visibleBlogId: blogId,
      visibleBlogForm: Boolean(blogId),
      categories: [],
      visibleUpdatingBlog: null,

      visibleCategoryId: undefined,
      visibleCategoryForm: false,
    };
  }

  showBlogStatusModal = (blog?: BlogOutputModel) => {
    this.setState({ visibleUpdatingBlog: blog || null });
  };

  openBlogFormModal = (code?: string) => {
    this.setState({ visibleBlogId: code, visibleBlogForm: true }, () => {
      if (code) {
        this.props.history.push(BlogUtil.buildBlogDetailPath(code));
      }
    });
  };

  closeBlogFormModal = (cb?: TCb) => {
    this.props.history.push(APP_ROUTES.BLOG.BASE);
    this.setState({ visibleBlogId: undefined, visibleBlogForm: false }, () => {
      loadCallback(cb?.success);
    });
  };

  onSearch = _.debounce((searchValue: string) => {
    this.setState(
      (prevState) => {
        return {
          filter: {
            ...prevState.filter,
            searchValue,
          },
        };
      },
      () => {
        this.onApplyFilter(false);
      }
    );
  }, 300);

  onChangeCategory = (categoryUrl: string) => {
    this.setState(
      {
        filter: {
          ...this.state.filter,
          categoryUrl,
        },
      },
      () => {
        this.onApplyFilter(false);
      }
    );
  };

  onApplyFilter = async (loadMore: boolean, cb?: TCb) => {
    if (this.state.fetchedBlog.loading && loadMore) return;
    await this.onLoadCategories();

    this.setState(
      (prevState) => {
        return {
          fetchedBlog: {
            ...prevState.fetchedBlog,
            data: loadMore ? prevState.fetchedBlog.data : [],
            loading: true,
          },
        };
      },
      () => {
        const query: Parameters<typeof BlogService.filterBlogs>[0] = {
          page: loadMore ? this.state.fetchedBlog.page + 1 : 1,
          limit: this.state.fetchedBlog.limit,
          searchValue: this.state.filter.searchValue || undefined,
          urlCategory: this.state.filter.categoryUrl,
          languageId: this.props.all_language_list.data.find((e: LanguageOutputModel) => e.isPrimary)?.id,
        };

        BlogService.filterBlogs(query)
          .then((res) => {
            if (res && res.data?.data) {
              this.setState(
                (prevState) => {
                  let blogs: BlogOutputModel[] = [...res.data.data];

                  if (loadMore) {
                    blogs.unshift(...prevState.fetchedBlog.data);
                  }

                  return {
                    fetchedBlog: {
                      ...res.data,
                      data: blogs,
                      loading: false,
                    },
                  };
                },
                () => {
                  loadCallback(cb?.success);
                }
              );
            } else {
              this.setState({
                fetchedBlog: INITIAL_FETCHING_PAGINATION_DATA,
              });
            }
          })
          .catch((err) => {
            this.setState({
              fetchedBlog: INITIAL_FETCHING_PAGINATION_DATA,
            });
          });
      }
    );
  };

  onLoadMore = () => {
    this.onApplyFilter(true);
  };

  onLoadCategories = () => {
    BlogService.filterCategories({ limit: 150, type: CATEGORY_TYPES.POST, languageId: this.props.all_language_list.data.find((e: LanguageOutputModel) => e.isPrimary)?.id })
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          // let cate: BlogCategoryOutputModel[] = [...res.data.data];
          // this.setState({ categories:  cate });

          let cates: BlogCategoryApiOutputModel[] = res.data.data;

          cates = cates.filter((cate) => cate.id !== BLOG_CATEGORY.PROMOTION.id);
          this.setState({ categories: cates });
        }
      })
      .catch((err) => {
        this.setState({
          categories: [],
        });
      });
  };

  onUpdateBlogStatus = () => {
    const blogId = this.state.visibleUpdatingBlog!.id;
    const newStatus = this.state.visibleUpdatingBlog!.status === BlogStatus.PUBLISH ? BlogStatus.UNPUBLISH : BlogStatus.PUBLISH;
    this.setState({ visibleUpdatingBlog: null }, () => {
      BlogService.updateBlog(blogId, { status: newStatus })
        .then((res) => {
          if (res && (res.status === 200 || res.status === 201)) {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.SUCCESS,
              message: "Update blog status success",
            });
            const blogs = this.state.fetchedBlog.data;
            const idx = blogs.findIndex((b) => b.id === blogId);

            if (idx !== -1) {
              blogs[idx].status = newStatus;
            }

            this.setState((prevState) => {
              return { fetchedBlog: { ...prevState.fetchedBlog, data: blogs } };
            });
          } else {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.ERROR,
              message: "Update blog status failed",
            });
          }
        })
        .catch((err) => {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Update blog status failed",
          });
        });
    });
  };

  openCategoryForm = (code?: string) => {
    this.setState({ visibleCategoryId: code, visibleCategoryForm: true }, () => {
    });
  };

  closeCategoryForm = (cb?: TCb) => {
    this.setState({ visibleCategoryId: undefined, visibleCategoryForm: false }, () => {
      loadCallback(cb?.success);
    });
  };

  onDeleteCategory = (code: string | null) => {
    code && CategoryService.deleteCategory(code!)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Delete category success",
          });
          this.onApplyFilter(false);
        } else {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Delete category failed",
          });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({
          type: AppNotifications.ERROR,
          message: "Delete category failed",
        });
      });
  };

  onDeleteBlog = (code: string | null) => {
    code && BlogService.deleteBlog(code!)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Delete blog success",
          });
          this.onApplyFilter(false);
        } else {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Delete blog failed",
          });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({
          type: AppNotifications.ERROR,
          message: "Delete blog failed",
        });
      });
  };

  render() {
    return (
      <BlogListingPresenter
        {...this.props}
        {...this.state}
        onChangeCategory={this.onChangeCategory}
        onLoadMore={this.onLoadMore}
        onSearch={this.onSearch}
        openBlogFormModal={this.openBlogFormModal}
        closeBlogFormModal={this.closeBlogFormModal}
        reloadListingPage={() => {
          this.onApplyFilter(false);
        }}
        showBlogStatusModal={this.showBlogStatusModal}
        onUpdateBlogStatus={this.onUpdateBlogStatus}
        reloadListingCatePage={() => {
          this.onLoadCategories();
        }}
        openCategoryForm={this.openCategoryForm}
        closeCategoryForm={this.closeCategoryForm}
        onDeleteCategory={this.onDeleteCategory}
        onDeleteBlog={this.onDeleteBlog}
      />
    );
  }

  componentDidMount() {
    if (this.state.visibleBlogId && this.state.visibleBlogForm) {
      // todo nếu vào form detail
    }
    if (!this.props.all_language_list.data.length) {
      this.props.actions.getAllLanguages({
        success: () => {
          this.onApplyFilter(false, {
            success: () => { },
          });
        }
      });
    } else {
      this.onApplyFilter(false, {
        success: () => { },
      });
    }
    if (!this.props.all_labels.data.length) {
      this.props.actions.getAllLabels();
    }
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({
      all_language_list: state.all_language_list,
      all_labels: state.all_labels
    }),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions, AllLanguageListActions, AllLabelsActions), dispatch),
    })
  )(BlogListingContainer)
);
